export const TabsMenuDisplayName = 'TabMenu';
